export const LoadedEnd = 'EOL_LOADED';

export const EOL_REACHED = 'EOL_REACHED';

export const isLoadedEnd = v => v === LoadedEnd;